/** Turn stored maintenance text into a sentence for the screen. */
export function readableMaintenanceDescription(raw: string): string {
  let text = (raw || '')
    .replace(/\[\[TECH:[^\]]*\]\]/gi, ' ')
    .replace(/\[\[RETURN_ID:\d+\]\]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  text = text.replace(/^Sent by [^.]+\.\s*/i, '').trim();
  if (!text) {
    return 'Repair required.';
  }

  const parts = text
    .split(/\s*·\s*/)
    .map((part) => part.trim())
    .filter(Boolean);
  const hasGeneratedParts = parts.some(
    (part) =>
      /^returned as /i.test(part) ||
      /^qty damaged:/i.test(part) ||
      /^n\/?a$/i.test(part),
  );
  if (!hasGeneratedParts) {
    return text;
  }

  const markerIndex = parts.findIndex(
    (part) =>
      /^returned as /i.test(part) ||
      /^qty damaged:/i.test(part) ||
      /^n\/?a$/i.test(part),
  );
  const notes = parts
    .slice(0, markerIndex === -1 ? parts.length : markerIndex)
    .filter((part) => !/^n\/?a$/i.test(part));
  const qtyPart = parts.find((part) => /^qty damaged:\s*\d+/i.test(part));
  const qty = qtyPart ? Number(qtyPart.replace(/^qty damaged:\s*/i, '')) : 0;
  const qtyText =
    qty > 1 ? `${qty} units returned damaged.` : 'Returned damaged.';
  const note = notes.join('. ').replace(/\.+$/, '').trim();

  if (note && qty > 1) {
    return `${note}. ${qtyText}`;
  }
  if (note) {
    return note.endsWith('.') ? note : `${note}.`;
  }
  return qtyText;
}

/** Problem text saved when a damaged return is sent to maintenance. */
export function maintenanceProblemFromDamage(input: {
  notes?: string;
  damageDescription?: string;
  quantityDamaged?: number;
}): string {
  const notes = (input.notes || '').trim();
  const damage = (input.damageDescription || '').trim();
  const usefulDamage =
    damage && !/^returned as /i.test(damage) && !/^n\/?a$/i.test(damage)
      ? damage
      : '';
  const qty = input.quantityDamaged ?? 0;
  const lead = [notes, usefulDamage].filter(Boolean).join('. ').replace(/\.+$/, '');

  if (qty > 1) {
    const qtyText = `${qty} units returned damaged.`;
    return lead ? `${lead}. ${qtyText}` : qtyText;
  }

  return lead ? (lead.endsWith('.') ? lead : `${lead}.`) : 'Returned damaged.';
}
